import { loadStates, loadStatus } from 'utils';


export const EditState = {
  showEditForm: false,
  editObject: null,
  editPreventLoadDetail: false,

  updateStatus: loadStatus(loadStates.notAsked),
};

export const EditReducers = {
  showEditForm(state, payload) {
    return {
      ...state,
      showEditForm: payload.show,
      editObject: payload.object,
      editPreventLoadDetail: payload.preventLoadDetail,
    };
  },

  updateRequest(state, payload) {
    return {
      ...state,
      updateStatus: loadStatus(loadStates.loading),
    };
  },

  updateComplete(state, payload) {
    if (payload.preventLoadDetail) {
      return {
        ...state,
        updateStatus: loadStatus(loadStates.loaded),
      }
    }
    return {
      ...state,
      updateStatus: loadStatus(loadStates.loaded),
      detail: payload,
    };
  },

  updateError(state, payload) {
    return {
      ...state,
      updateStatus: loadStatus(loadStates.failed, payload),
    }
  },
}
